import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { passwordStrengthValidator } from 'app/validations/password-strength.validator';
import { matchPasswords } from 'app/validations/match-passwords.validator';
import { Log } from 'app/core/logging/log';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

    @Output() goTo = new EventEmitter<any>();
    @Output() callbackFunction = new EventEmitter<any>();
    form: FormGroup;
    passwordStrength = 0;

    constructor(
        private restService: RestService,
        private appService: AppService,
    ) { }

    ngOnInit() {
        this.initForm();
    }

    initForm(){

        this.form = new FormGroup(
            {
            'tenantId': new FormControl(this.appService.tenantId,[
                Validators.required,
                Validators.min(1)
            ]),
            'email': new FormControl('',[
                Validators.required,
                //Validators.minLength(4),
                Validators.email
            ]),
            'password': new FormControl('',[
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(20),
                //Validators.pattern("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}")
                //Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{6,}$")
                passwordStrengthValidator()
            ]),
            'passwordConfirm': new FormControl('',[
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(20),
                //Validators.pattern("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}")
                //Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{6,}$")
            ]),
            'langCode': new FormControl(AppService.langSel.name, [
                Validators.required
            ])
            },
            {   
                //validators: this.passwordValidation.bind(this)
                validators: matchPasswords('password', 'passwordConfirm')
            }
        );
        
        this.form.get('password')?.valueChanges.subscribe(() => {
            const control = this.form.get('password');
            const errors = control?.errors as any;
            this.passwordStrength = errors?.strength ?? 0;
        });

    }

    passwordValidation(formGroup: FormGroup) {
        const { value: password } = formGroup.get('password');
        const { value: passwordConfirm } = formGroup.get('passwordConfirm');
        return password === passwordConfirm ? null : { passwordNotMatch: true };
    }

    get tenantId() { return this.form.get('tenantId'); }
    get email() { return this.form.get('email'); }
    get password() { return this.form.get('password'); }
    get passwordConfirm() { return this.form.get('passwordConfirm'); }
    
    _goTo(value: string){
        Log.debug("_goTo", {value});
        this.goTo.emit(value);
    }

    signup(){
        this.validateAllFormFields(this.form);
        if (this.form.invalid) {
            Log.debug("Formulario no valido", {form:this.form});
            return;
        }

        this.appService.tenantId = Number(this.form.get('tenantId')?.value);
        this.restService.registro(this.form.value).subscribe(result => {
            this.appService.showSuccessToast('Bienvenido');
            this.appService.usuario.username = result.username;
            this.appService.usuario.id = result.id;
            this.appService.usuario.email = result.email;
            this.appService.setToken(result.token);
            AppService.autenticado = true;
            this.appService.setCurrentUser(result);
            this.callbackFunction.emit();
        });
      }
    

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
          const control = formGroup.get(field);
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
          } else if (control instanceof FormGroup) {
            this.validateAllFormFields(control);
          }
        });
    }

}
